import { z } from "zod";

export const WorkStyleType = z.union([
  z.literal("PERFORMER"),
  z.literal("LEADER"),
  z.literal("TEAM_PLAYER"),
  z.literal("COOL_HEADED"),
  z.literal("HARD_WORKING"),
  z.literal("INDEPENDENT"),
  z.literal("PROBLEM_SOLVER"),
]);

export type WorkStyleType = z.infer<typeof WorkStyleType>;
